
/*
 *
 * Date: 2025
 * Description: setting form for app gesture
 * Author: Philippe Leroux @SKITSC
 *
 */
//Modules
import { Box , TextField , Typography , Button, Paper , Switch } from "@mui/material"
import { ChangeEvent , useState } from "react"

//Interfaces
import { i_settings_form } from "../../interfaces/display.interfaces"
import { i_settings } from "../../interfaces/items.interface"
import { t_run } from "../../types/types"

//Icons

const SettingForm = ( props : i_settings_form ) => {
    const handleField = ( event : ChangeEvent<HTMLInputElement> ) => {
        const { name, value , checked } = event.target
        if(name === 'active'){
            props.setForm({...props.form, [name] : checked })
        }else{
            if(name.includes('mail-')){
                const parsedName = name.split('-')[1]
                if(parsedName === 'secure' || parsedName === 'pool'){
                    props.setForm({...props.form,  mailConfig : {...props.form.mailConfig, [parsedName] : checked } })
                }else{
                    props.setForm({...props.form,  mailConfig : {...props.form.mailConfig, [parsedName] : value} })
                }
            }else{
                if(name.includes('vendor-')){
                    console.log('handle vendor')
                }else{
                    props.setForm({...props.form, [name] : value})
                }
            }
        }
    }
    const lookVendors = ( run : t_run ) => {
        if(props.form.vendors && props.form.vendors.includes(run)){
            return true
        }
        return false
    }
    const F : i_settings = props.form
    const E : i_settings = props.errors
    const btnSubmit = { width: '100%', maxWidth : '300px' , marginLeft : 'auto' , marginRight : 'auto' , marginTop: '1vh'}
    const boxingRow = { display : 'flex' , alignSelf : 'center' , alignItems : 'center' , width : '100%' , marginBottom : '1vh'}
    const labelTitle = { width : '35%' , textAlign : 'center' , fontSize : 16 , fontWeight : 'bolder'}
    const inputShape = { width : '65%' , maxWidth :" 400px"}
    return (
        <Box sx={{ padding : 5 , maxWidth : '800px' , marginLeft : 'auto' , marginRight : 'auto'}}>
            <Box sx={{ display : 'flex' , flexDirection : 'column'}}>
                <Paper sx={{ padding : 2 , marginBottom : 2}}>
                    <Box>
                        <Typography variant="h5" sx={{ textAlign : 'center' , marginBottom : 2}}>App setting's</Typography>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Percent price increase:</Typography>
                        <TextField sx={inputShape} type="number" autoComplete="off" name={'perPrice'} value={F.perPrice} onChange={handleField}/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Flat price increase:</Typography>
                        <TextField sx={inputShape} type="number" autoComplete="off" name={'flatPrice'} value={F.flatPrice} onChange={handleField}/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Email that receives quotes or events:</Typography>
                        <TextField sx={inputShape} autoComplete="off" name={'email'} value={F.email} onChange={handleField} helperText={E.email} error={E.email !== ''? true : false }/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Activate user hub :</Typography>
                        <Switch checked={F.active} name="active" onChange={handleField} />
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Select' vendors for price match :</Typography>
                        <Box sx={{ display : 'flex', justifyContent:'space-between'}}>
                            <TextField variant={'standard'} type={"checkbox"} helperText={'Atpac'} value={lookVendors('atpac')} onChange={handleField} name={'vendor-atpac'}/>
                            <TextField variant={'standard'} type={"checkbox"} helperText={'PartsAvatar'} value={lookVendors('partsavatar')} onChange={handleField} name={'vendor-partavatar'}/>
                            <TextField variant={'standard'} type={"checkbox"} helperText={'Tiger'} value={lookVendors('tiger')} onChange={handleField} name={'vendor-tiger'}/>
                            <TextField variant={'standard'} type={"checkbox"} helperText={'Moneydex'} value={lookVendors('moneydex')} onChange={handleField} name={'vendor-moneydex'}/>
                            <TextField variant={'standard'} type={"checkbox"} helperText={'LKQ'} value={lookVendors('lkq')} onChange={handleField} name={'vendor-lkq'}/>
                            <TextField variant={'standard'} type={"checkbox"} helperText={'Rockauto'} value={lookVendors('rockauto')} onChange={handleField} name={'vendor-rockauto'}/>
                        </Box>
                    </Box>
                </Paper>
                <Paper sx={{ padding : 2}}>
                    <Box >
                        <Typography variant="h5" sx={{ textAlign : 'center' , marginBottom : 2}}>Mail configuration</Typography>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Host address :</Typography>
                        <TextField sx={inputShape} type="text" autoComplete="off" name={'mail-host'} value={F.mailConfig.host} onChange={handleField} helperText={E.mailConfig.host} error={E.mailConfig.host!== ''? true : false }/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Use secure feature :</Typography>
                        <Switch checked={F.mailConfig.secure} name="mail-secure" onChange={handleField} />
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Username :</Typography>
                        <TextField sx={inputShape} type="text" autoComplete="off" name={'mail-username'} value={F.mailConfig.username} onChange={handleField} helperText={E.mailConfig.username} error={E.mailConfig.username!== ''? true : false }/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Password:</Typography>
                        <TextField sx={inputShape} type="password" autoComplete="off" name={'mail-password'} value={F.mailConfig.password} onChange={handleField} helperText={E.mailConfig.password} error={E.mailConfig.password!== ''? true : false }/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Email sent from address :</Typography>
                        <TextField sx={inputShape} type="email" autoComplete="off" name={'mail-from'} value={F.mailConfig.from} onChange={handleField} helperText={E.mailConfig.from} error={E.mailConfig.from!== ''? true : false }/>
                    </Box>
                    <Box sx={boxingRow}>
                        <Typography sx={labelTitle}>Use pool :</Typography>
                        <Switch checked={F.mailConfig.pool} name="mail-pool" onChange={handleField} />
                        <Button sx={{ marginLeft : '275px'}} variant="contained" onClick={() => props.callback('test')}>Test</Button>
                    </Box>
                </Paper>
                <Button type="button" sx={btnSubmit} loading={props.loading} variant="contained" onClick={() => props.callback('update')}>Submit</Button>
            </Box>
        </Box>
    )
}

export default SettingForm;